import Phaser           from 'phaser';
import {gameWindowSize} from '../constants/appConstants';
import MainScene        from '../elements/Scenes/MainScene';
import PauseScene        from '../elements/Scenes/PauseScene';
import InitScene        from '../elements/Scenes/InitScene';


export function initGame () {
    const config = {
        type: Phaser.AUTO,
        parent: 'root',
        width: gameWindowSize.width,
        height: gameWindowSize.height,
        physics: {
            default: 'arcade',
            arcade: {
                debug: false
            }
        },
        scene: [InitScene, MainScene, PauseScene]
    };

    return new Phaser.Game( config );
}
